import { stringify } from "query-string";
import { GET_LIST, GET_ONE, CREATE, DELETE } from "react-admin";
import { auth } from "../../firebase";
import { QA_API_ERROR } from "../../util";

const AdminProvider = opt => {
  const { config, httpClient } = opt;
  if (!config) {
    throw new Error("Missing config");
  }
  if (!httpClient) {
    throw new Error("Missing httpClient");
  }
  const provider = {
    handle(type, params) {
      switch (type) {
        case GET_LIST:
          return provider.list(params);
        case GET_ONE:
          return provider.get(params);
        case CREATE:
          return provider.create(params);
        case DELETE:
          return provider.delete(params);
        default:
          throw new Error(`Unsupported action type: ${type}`);
      }
    },
    get(params) {
      return httpClient
        .get(`/api/admin/admin/${params.id}`)
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("AdminProvider.get Error", result, params);
          }
          let response = {
            data: result.admin
          };
          return response;
        });
    },
    list(params) {
      const query = {
        order: params.sort.field,
        sort: params.sort.order.toLowerCase(),
        limit: params.pagination.perPage
      };
      // pagination
      if (typeof params.pagination.page === "string") {
        const [pageNumber, afterOrBefore, id] = params.pagination.page.split(
          "_"
        );
        if (afterOrBefore === "after") {
          query.after = id;
        } else if (afterOrBefore === "before") {
          query.before = id;
        }
        console.log("pageNumber: ", pageNumber);
      }
      return httpClient
        .get(`/api/admin/admins?${stringify(query)}`)
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("AdminProvider.list Error", result, params);
          }
          let response = {
            data: result.admins || null,
            total: result.admins.length
          };
          return response;
        });
    },
    create(params) {
      return auth.currentUser
        .getIdToken(false)
        .then(token => {
          return httpClient.post(`/api/admin/admins`, {
            ...params.data,
            token
          });
        })
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("AdminProvider.create Error", result, params);
          }
          const response = {
            data: result.admin
          };
          return response;
        });
    },
    delete(params) {
      return auth.currentUser
        .getIdToken(false)
        .then(token => {
          return httpClient.delete(`/api/admin/admin/${params.id}`, {
            data: { token }
          });
        })
        .then(res => res.data)
        .then(result => {
          if (result.status !== "success") {
            throw QA_API_ERROR("AdminProvider.delete Error", result, params);
          }
          const response = {
            data: result.deletedAdmin
          };
          return response;
        });
    }
  };
  return provider;
};

export default AdminProvider;
